module.exports = __webpack_public_path__ + "static/img/十不准.b66f5c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/十不准.jpg
// module id = 21+2
// module chunks = 1